import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalForm } from 'src/components/form/form/ModalForm';

import { useInsertUserGroup } from '@/hooks/mutations/user-group';

import UserGroupFormFields from './forms/UserGroupFormFields';
import type { UserGroupFormFieldsSchema } from './forms/userGroupSchema';
import { defaultValues, UserGroupSchema } from './forms/userGroupSchema';

type Props = {
  onDismiss: () => void;
};

const AddGroupModal: FC<Props> = ({ onDismiss }) => {
  const { t } = useTranslation('common');
  const { insertUserGroup } = useInsertUserGroup();

  const onSave = async (data: UserGroupFormFieldsSchema) => {
    const result = await insertUserGroup(data);
    const userGroupId = result?.insert_user_group_one?.Id;
    if (!userGroupId) {
      throw new Error('Id not found');
    }
  };

  const formId = 'add-user-group-form';

  return (
    <ModalForm
      i18n={t('userGroups')}
      defaultValues={defaultValues}
      schema={UserGroupSchema}
      onSave={onSave}
      onDismiss={onDismiss}
      formId={formId}
      visible={true}
    >
      <UserGroupFormFields />
    </ModalForm>
  );
};

export default AddGroupModal;
